import React from 'react';
export const InvoiceListPoMatchTypeCell = ({ rowData }) => (React.createElement("span", { className: "text-xs text-black" }, rowData.poMatchType ?? 'Non-PO'));
